import React, { useState, useCallback } from "react";
import LoginModal from "./ModalComponents/LoginModal";
import SignUpModal from "./ModalComponents/SignUpModal";
import "../css/Home.css";

const Home = () => {
  const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);
  const [isLoginView, setIsLoginView] = useState(true);

  const openGetStarted = useCallback(() => setIsGetStartedOpen(true), []);
  const closeGetStarted = useCallback(() => setIsGetStartedOpen(false), []);
  const toggleView = useCallback(
    () => setIsLoginView((isLoginView) => !isLoginView),
    [],
  );

  return (
    <div className="Home">
      <h1>bring your menu to life</h1>
      <div className="dishes">
        <img src="/plate1.png" alt="plate 1" />
        <img src="/plate2.png" alt="plate 2" />
        <img src="/plate3.png" alt="plate 3" />
        <img src="/plate4.png" alt="plate 4" />
        <img src="/plate5.png" alt="plate 5" />
        <img src="/plate6.png" alt="plate 6" />
      </div>
      <h2>
        with just a scan, view 3D models of menu items directly on your table
        and make confident, informed choices before you order
      </h2>
      <button className="get-started-home" onClick={openGetStarted}>
        get started
      </button>

      {isGetStartedOpen && isLoginView && (
        <LoginModal
          className="get-started-modal"
          isOpen={isGetStartedOpen}
          onRequestClose={closeGetStarted}
          toggleView={toggleView}
          width="80%"
        />
      )}

      {isGetStartedOpen && !isLoginView && (
        <SignUpModal
          className="get-started-modal"
          isOpen={isGetStartedOpen}
          onRequestClose={closeGetStarted}
          toggleView={toggleView}
          width="80%"
        />
      )}
    </div>
  );
};

export default Home;
